import styled from '@emotion/styled';
import NoLogInPageWeb from 'components/layout/NoLogOutPageWeb';
import Button from "components/ui/Button";

import { usePostInputUserDetail } from "hooks/api"
import { useState, useEffect } from 'react';
import { useDaumPostcodePopup } from 'react-daum-postcode';
import { useNavigate } from 'react-router-dom';
import ReactGA from "react-ga4";

interface DetailInfo {
  name?:string;
  mobile?:string;
  postalNumber: string;
  defaultAddress: string;
  zoneCode: string;
  detailAddress?:string;
};

const Elem:React.FC<any> = () => {
  const { mutateAsync : postInputUserDetail } = usePostInputUserDetail();
  const [ detailInfo, setDetailInfo ] = useState<DetailInfo>({
    name:"",
    mobile:"",
    postalNumber: "",
    defaultAddress: "",
    zoneCode:"",
    detailAddress:""
  });
  const gaId = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;

  const navigator = useNavigate();
  const scriptUrl = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';

  const open = useDaumPostcodePopup(scriptUrl);

  const handleComplete = async (data:any) => {
    setDetailInfo(prevInfoData => ({
      ...prevInfoData,
      postalNumber: data?.zonecode || "",
      defaultAddress : data?.address || "",
      zoneCode: data?.jibunAddress || ""
    }))
  };

  const handleName = (event:any) => {
    setDetailInfo({
      ...detailInfo , name: event?.target.value, 
    })
  };

  const handlePhone = (event:any) => {
    setDetailInfo({
      ...detailInfo, mobile: event.target.value
    })
  };

  const handleDetailAddress = (event:any)=> {
    setDetailInfo({
      ...detailInfo, detailAddress: event.target.value
    })
  };

  const handleClick = async ()=> {
    await open({ onComplete: handleComplete})
  };

  const UploadUerDetail = async () => {
    const result = await postInputUserDetail({
      detailInfo
    })
  }
  
  const handleGoToPlan = async () => {
    if (detailInfo.name && detailInfo.mobile && detailInfo.postalNumber && detailInfo.defaultAddress && detailInfo.detailAddress) {
      await UploadUerDetail();
      navigator("/onboarding/3/plan");

      ReactGA.event({
        "category": "Button",
        "action" : "Click",
        "label" : "go to subs plan"
      })
    }
  };

  useEffect(() => {
    if (gaId) {
      ReactGA.send({ hitType: "pageview", page:"/onboarding/2/detail", title: "input user detail view" })
    }
  },[])
  


  return (
    <NoLogInPageWeb disable={false}>
      <Container>
        <Body>
          <TextContainer>
            <SmallText className="first"><span>1/3</span>단계</SmallText>
            <BigText >배송 정보를 입력하세요</BigText>
            <SmallText className="small">1~2일내 무료체험이 배송돼요.</SmallText>
          </TextContainer>
          <ContextContainer> 
            <SmallText>이름</SmallText>
            <TextInput 
              type="text"
              placeholder="김포티"
              onChange={handleName}
            ></TextInput>
            <SmallText className="Second">휴대전화 번호</SmallText>
            <TextInput 
              type="text"
              placeholder="0000000000"
              onChange={handlePhone}
              />
            <SecontTextContainer>
              <SmallText>배송지</SmallText>
              <FirstLine>
                <TextInput 
                  className="small"
                  placeholder="우편번호"
                  // type="text"
                  // onChange={handleZonecode}
                  value={detailInfo.postalNumber || ""}/>
                <ButtonContainer>
                  <Button 
                    layoutVariant="contained"
                    variant="default"
                    onClick={handleClick}
                    expand
                  >
                    주소 검색
                  </Button>
                </ButtonContainer>
              </FirstLine>
              <TextInput 
                className="default"
                placeholder="주소"
                value={detailInfo.defaultAddress || ""}
                />
              <TextInput 
                className="default" 
                placeholder="상세 주소를 입력하세요"
                type="text"
                onChange={handleDetailAddress}
                value={detailInfo.detailAddress || ""}
              />
            </SecontTextContainer>
          </ContextContainer>
        <ButtonWrapper>
          <SubmitButton 
            layoutVariant="contained"
            variant="default"
            expand
            isActive={
              !!(detailInfo.name 
                && detailInfo.mobile
                && detailInfo.postalNumber
                && detailInfo.defaultAddress
                && detailInfo.detailAddress
              )
            }
            onClick={handleGoToPlan}
          >
            간편 인화 플랜 보기
          </SubmitButton>
        </ButtonWrapper>
        </Body>
      </Container>
    </NoLogInPageWeb>
  );
};

export default Elem;

const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 80vh;
  display: flex;
  flex-direction: column;
  padding: 24px 17px;
`;
const Body = styled.div`
  width: 344px;
  margin:40px auto;
`;
const TextContainer = styled.div`
  width: 220px;
  height: 50px;
  display: flex;
  flex-direction: column;
  margin-left: -10px;
`;
const SmallText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 300;
  font-size: 13px;
  line-height: 100%;
  color: #141414;

  span {
    font-weight: 700;
  }
  &.first {
    margin-bottom: 15px;
  }
  &.Second {
    margin-top: 12.37px;
  }
  &.small{
    margin-top: 10px;
    color: rgba(117, 117, 117, 1);
  }
`;
const BigText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-size: 24px;
  line-height: 100%;
  color: #141414;
  font-weight: bold;

  &.Top {
    font-weight: 500;
    margin-bottom: 5px;
  }

  &.Bottom {
    font-weight: 300;
  }
`;
const ContextContainer = styled.div`
  width: 344px;
  height: 356px;
  margin: 50px auto 0;
  display: flex;
  flex-direction: column;
`;
const TextInput = styled.input`
  width: 100%;
  height: 45.7px;
  border: 0.8px solid #444444;
  border-radius: 0;
  margin-top: 8.8px;

  &.default {
    margin-top: 7.61;
  }

  &.small {
    width: 210.93px;
    margin-top: 0px ;
  }
`;
const SecontTextContainer = styled.div`
  width: 100%;
  height: 175.14px;
  margin-top: 30.46px;
  display: flex;
  flex-direction: column;
`;
const FirstLine = styled.div`
  width: 100%;
  height: 45.69px;
  display: flex;
  flex-direction: row;
  margin-top: 8.8px;
  justify-content: space-between;
`;
const ButtonContainer = styled.div`
  width: 102px;
  height: 100%;
`;
const ButtonWrapper =styled.div`
  /* width: 300px; */
  width: 100%;
  height: 52px;
  margin: 85px auto 0;
`;
interface ButtonProps {
  isActive:boolean;
}
const SubmitButton = styled(Button)<ButtonProps>`
  border: 1px solid ${({ isActive }) => (isActive? 'rgba(20, 20, 20, 1)' : `rgba(177, 177, 177, 1)`)};
  color :${({ isActive }) => (isActive? 'rgba(20, 20, 20, 1)' : `rgba(177, 177, 177, 1)`)};
  cursor: ${({ isActive }) => (isActive ? 'pointer' : 'not-allowed')};
`;

